<template>
  <v-form ref="cashiersForm">
    <v-row>
      <v-col cols="12" md="12">
        <p class="text-h6">Informacion General</p>
      </v-col>
      <v-col class="mt-n5" cols="12" md="12">
        <v-text-field
          v-model="data.Nombre"
          :rules="rules.Nombre"
          label="Nombre Periodo"
          outlined
          dense
          required
        ></v-text-field>
      </v-col>
      <v-col class="mt-n7" cols="12" md="12">
        <v-select
          v-model="data.Pagos"
          :rules="rules.Pagos"
          label="Numero de pagos al año"
          :items="tiposPagos"
          outlined
          dense
          required
        ></v-select>
      </v-col>
      <v-col class="mt-n7" cols="12" md="12">
        <v-text-field
          v-model="data.Prorroga"
          :rules="rules.Prorroga"
          type="number"
          label="Días de prorroga de pago"
          outlined
          dense
          required
        ></v-text-field>
      </v-col>
    </v-row>
    <div class="text-right">
      <v-btn large @click="$emit('toggle', false)">Cancelar</v-btn>
      <v-btn style="margin-left: 6px" color="success" large @click="checkForm"
        >Guardar</v-btn
      >
    </div>
  </v-form>
</template>

<style scoped></style>

<script>
import Currency from "../../../clases/Currencies.js";
import PeriodosCobro from "../../../clases/Membresias/PeriodosCobro.js";
export default {
  name: "PeriodoPagoForm",
  components: {},
  props: ["edit", "dataEdit"],
  data() {
    return {
      currencyClass: Currency,
      monedas: [],
      data: PeriodosCobro.getPropertyModel(),
      rules: PeriodosCobro.rules,
      tiposPagos: PeriodosCobro.getTiposPagos(),
    };
  },
  methods: {
    checkForm() {
      if (this.$refs.cashiersForm.validate()) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }
        this.send(doAction);
      }
    },
    send(action) {
      let dataSave = this.data;
      dataSave.Pagos = Number(dataSave.Pagos);
      dataSave.Prorroga = Number(dataSave.Prorroga);
      dataSave.Periodos = Number(12 / dataSave.Pagos);
      /*if (action === "EDIT") {
        // id de edicion
        dataSave.Id = this.dataEdit.id;
      }*/
      this.$emit("successData", dataSave, action);
    },
  },
  mounted() {
    //localStorage.getItem("selectedDepartment");
    if (this.edit) {
      this.data = this.dataEdit;
      /*(this.data.Nomb   = this.dataEdit.Nomb),
      (this.data.Activo = this.dataEdit.Activo),
      (this.data.CA.C   = this.dataEdit.CA.C),
      (this.data.CA.M   = this.dataEdit.CA.M),
      (this.data.CPA.C  = this.dataEdit.CPA.C),
      (this.data.NM  = this.dataEdit.NM),
      (this.data.CPA.M  = this.dataEdit.CPA.M);
      (this.data.TIA  = this.dataEdit.TIA);
      (this.data.Cve  = this.dataEdit.Cve);*/
    }
  },
};
</script>
